import { render, staticRenderFns } from "./DistributorModal.vue?vue&type=template&id=5c66ee3e&scoped=true&"
import script from "./DistributorModal.vue?vue&type=script&lang=js&"
export * from "./DistributorModal.vue?vue&type=script&lang=js&"
import style0 from "./DistributorModal.vue?vue&type=style&index=0&id=5c66ee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66ee3e",
  null
  
)

export default component.exports